import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f344983e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "strip-menu-item-icon"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 0,
  class: "longline"
};
const _hoisted_4 = {
  key: 1,
  class: "longline"
};
const _hoisted_5 = {
  class: "d-flex flex-row align-items-center gap-12px",
  style: {
    "width": "100%"
  }
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "longline"
};
const _hoisted_8 = {
  key: 1,
  class: "longline"
};
const _hoisted_9 = {
  style: {
    "width": "100%",
    "color": "#fff"
  }
};
const _hoisted_10 = {
  style: {
    "color": "#757575 !important"
  }
};
const _hoisted_11 = {
  key: 3
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_feature = _resolveComponent("feature");
  const _component_alerts_notification_badge = _resolveComponent("alerts-notification-badge");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  return _openBlock(), _createBlock(_component_feature, {
    name: $options.getFeatureName($props.item)
  }, {
    default: _withCtx(() => [$options.showMenuIcon ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: _cache[0] || (_cache[0] = $event => $options.onClick($props.item)),
      class: _normalizeClass(["strip-menu-item menu-text-style", {
        open: $options.isOpen,
        active: $options.isActive
      }])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [$props.item.icon ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: $props.item.icon,
      color: "var(--menu-icon-color)",
      size: "16"
    }, null, 8, ["icon"])) : _createCommentVNode("", true)])]), _createElementVNode("div", {
      class: _normalizeClass(["menu-children", {
        open: $options.isOpen
      }])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, (child, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: child.text,
        style: {
          "position": "relative"
        }
      }, [_createVNode(_component_feature, {
        name: $options.getFeatureName(child)
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([{
            active: $options.isChildActive(child),
            selected: $options.isChildActive(child)
          }, "d-flex flex-row align-items-center menu-item-child-link collapsed"]),
          style: {
            "padding": "8px"
          },
          onClick: $event => $options.onClick(child)
        }, [index != $props.item.children.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_app_icon, {
          class: "line",
          icon: "side-bar-long-line"
        }), $options.isChildActive(child) ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 0,
          class: "selected-item-line",
          icon: "selected-item-line"
        })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_app_icon, {
          class: "branch-line",
          icon: "last-item-line"
        }), $options.isChildActive(child) ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 0,
          class: "selected-last-item-line",
          icon: "selected-last-item-line"
        })) : _createCommentVNode("", true)]))], 10, _hoisted_2)]),
        _: 2
      }, 1032, ["name"])]);
    }), 128))], 2)], 2)) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass([{
        open: $options.isOpen,
        active: $options.isActive,
        ['is-parent']: $props.item.children
      }, "menu-item menu-text-style"])
    }, [_createElementVNode("div", {
      class: "d-flex flex-row menu-item-link",
      onClick: _cache[1] || (_cache[1] = $event => $options.onClick($props.item))
    }, [_createElementVNode("div", null, [$props.item.icon ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: $props.item.icon,
      color: "var(--menu-icon-color)",
      size: "16"
    }, null, 8, ["icon"])) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_5, [_createTextVNode(_toDisplayString($props.item.text) + " ", 1), $props.item.url === '/alerts-page' ? (_openBlock(), _createBlock(_component_alerts_notification_badge, {
      key: 0
    })) : _createCommentVNode("", true)]), $props.item.children ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: $props.item.text === $props.openItemText ? 'chevron-down-new-ui' : 'chevron-right-new-ui',
      color: "var(--menu-icon-color)"
    }, null, 8, ["icon"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: _normalizeClass(["menu-children", {
        open: $options.isOpen
      }])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.item.children, (child, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: child.text,
        style: {
          "position": "relative"
        }
      }, [_createVNode(_component_feature, {
        name: $options.getFeatureName(child)
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([{
            active: $options.isChildActive(child),
            selected: $options.isChildActive(child)
          }, "d-flex flex-row align-items-center menu-item-child-link"]),
          onClick: $event => !child.disabled ? $options.onClick(child) : null
        }, [index != $props.item.children.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_app_icon, {
          class: "line",
          icon: "side-bar-long-line"
        }), $options.isChildActive(child) ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 0,
          class: "selected-item-line",
          icon: "selected-item-line"
        })) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_app_icon, {
          class: "branch-line",
          icon: "last-item-line"
        }), $options.isChildActive(child) ? (_openBlock(), _createBlock(_component_app_icon, {
          key: 0,
          class: "selected-last-item-line",
          icon: "selected-last-item-line"
        })) : _createCommentVNode("", true)])), child.disabled ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
          key: 2,
          placement: "right",
          width: "fit-content",
          styles: {
            width: '100%'
          },
          offset: 40
        }, {
          content: _withCtx(() => [_createElementVNode("span", _hoisted_9, _toDisplayString(child.disabledText), 1)]),
          default: _withCtx(() => [_createElementVNode("span", _hoisted_10, _toDisplayString(child.text), 1)]),
          _: 2
        }, 1024)) : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(child.text), 1))], 10, _hoisted_6)]),
        _: 2
      }, 1032, ["name"])]);
    }), 128))], 2)], 2))]),
    _: 1
  }, 8, ["name"]);
}